import { render, staticRenderFns } from "./VerifiedAssessmentAdminDashboard.vue?vue&type=template&id=2e0a9fd2&scoped=true&"
import script from "./VerifiedAssessmentAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./VerifiedAssessmentAdminDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./VerifiedAssessmentAdminDashboard.vue?vue&type=style&index=0&id=2e0a9fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a9fd2",
  null
  
)

export default component.exports